import i51 from '../../img/pasta/51.jpg'
import i52 from '../../img/pasta/52.jpg'

export const pasta=[
    {
        "id" : 51 ,
        "title" : "چیزپاستا",
        "price":"150",
        "desciption":"پاستا پنه ،استیک مرغ ، پنیر موزارلا ، سس آلفردو و فلفل دلمه ای",
        "image" : i51
    },
    {
        "id" : 52 ,
        "title" : "پاستا پنه چیکن آلفردو (مرغ)",
        "price":"160",
        "desciption":"پاستا پنه ، پنیر پارمسان ، استیک مرغ ، قارچ و سس آلفردو",
        "image" : i52
    },
    
]